module.exports = __webpack_public_path__ + "de543a4e9dc2572d844d8551e43ff147.svg";